module.exports = __webpack_public_path__ + "img/title.ac3957de.svg";